// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_bi-0";
export var actionModalContentContainer = "_bi-1";